import { Component,ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController,LoadingController } from 'ionic-angular';
import { Button } from 'ionic-angular/components/button/button';
import { UUID } from 'angular2-uuid';
import { MesasProvider } from '../../providers/mesas/mesas'

import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'
import { Storage } from '@ionic/storage'
import { NUBE_AWS } from '../../config/url.servicio';
import { UtilsProvider } from '../../providers/utils/utils'

@IonicPage()
@Component({
  selector: 'page-mesas',
  templateUrl: 'mesas.html',
  providers: [ AuthService ]
})
export class MesasPage {
  @ViewChild('Button') boton: Button;
  lista = []
  listaMuestra = []
  listasillas = []
  listasillasRecorrer = []
  data = []
  cantidades:number = 0
  mesas:any
  width:any
  height:any
  startLeft:any = "-30"
  startTop:any ="120"
  sillas:number=0
  colores:any = []
  codigosalon:string=""
  nombresalon:string=""

  salonesId: string = ""
  numeroUbicacion: string = ""
  anchoUbicacion: string = ""
  altoUbicacion: string = ""
  anchoSalon: string = ""
  altoSalon: string = ""
  personasPorUbicacion: string = ""
  estado: string = ""
  loader
  datos = []
  actualizar = []
  numeroMesaEliminar:number = 0
  numeroMesaAsignar:number = 0
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public alertControllers:AlertController,
    public servicio:MesasProvider,
    public loaders:LoadingController ,
    public servicioCompania:CompaniasProvider,
    public auth: AuthService,
    public storages:Storage,
    public utils: UtilsProvider
  ) {
      this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
      .then((val)=>{
        if(val){
          this.nombreCompaniaHeader = val['nombreCompania']
          this.nombreCargoHeader = val['nombreCargo']
        }
      })
      this.colores.push({nombre:'naranjado',coloresId:'#b3542f'})
      this.colores.push({nombre:'cafe',coloresId:'#3d3636'})
      this.colores.push({nombre:'amarillo',coloresId:'#b4eb1f'})
      this.colores.push({nombre:'rojo',coloresId:'#7e1111'})
      this.colores.push({nombre:'verde oscuro',coloresId:'#042020'})
      this.colores.push({nombre:'gris',coloresId:'#445363'})
      this.colores.push({nombre:'lila',coloresId:'#f4f4f4'})
      this.colores.push({nombre:'negro',coloresId:'#000000'})

      this.buscarDatos()
    }

    buscarDatos(){
      this.storages.get('companiasId').then((val)=>{
      this.servicio.buscarMesasPorCompania(val)
      .subscribe(
        (res: any) => {
          if(NUBE_AWS){
            res =  res.data[0] === undefined ? [] : res.data
          }
          if (res[0] !== undefined) {
          for(var k = 0; k < res[0].length;k++){
            this.listaMuestra.push({
                'left':res[0][k].leftt,
                'width':res[0][k].width,
                'top':res[0][k].topp,
                'height':res[0][k].height,
                'id': res[0][k].id,
                'color':'#4e6b66', //res[k].color,
                'Uuid': res[0][k].Uuid,
                'name' : "dataDynamicCrud",
                'queHago' : "I",
                'nombreTabla' : "mesas"
              })

          }
        }
          if (res[1] !== undefined) {
            for (var k = 0; k < res[1].length; k++) {
              this.listaMuestra.push({
                'left': res[1][k].leftt,
                'width': res[1][k].width,
                'top': res[1][k].topp,
                'height': res[1][k].height,
                'id': res[1][k].id,
                'color':'#4e6b66',
                'Uuid': res[1][k].Uuid,
                'name': "dataDynamicCrud",
                'queHago': "I",
                'nombreTabla': "mesas",
                sinAsignar: true,
              });
          }
        }
        },
        error => {
          console.log(error)
        }
      )
    })
      this.actualizar['valor']= true
    }

    actualizarData(){
      this.actualizar['valor']= false
      this.listaMuestra = []
      this.lista = []
    }

    recorrer(){
      this.listaMuestra = []
      this.storages.get('companiasId').then((val)=>{
      this.servicio.eliminarMesasTodasPorCompanias(val)
      .subscribe(
        (res:any) => {
          if(res['data'][0][0].elimino === 'S') {
            this.procesasDatos()
          } else {
            this.utils.mensajeMuestro('Mesas',`Recuerde, El registro no se agrego debe gestionar primero TODAS LAS MESAS desde caja`,'success')
          }
        },
        err => {
          this.loader = this.loaders.create({});
          this.loader.present();
          this.utils.mensajeMuestro('Mesas','No se pudo generar el guardado de información, intente luego','error')
        }
      )
    })
    }

    sacarMensajeBoton(id:any){
        this.mostrarMensajes("Mesa #" + id,"")
        this.utils.mensajeMuestro('Mesas',`Mesa #  ${id}`,'success')
    }
    procesasDatos(){
      let valor = document.getElementById('recorrer' )
      this.datos = []
        var k = 0

      this.storages.get('companiasId').then((val)=>{
        let compania = val
        let cantidad:number = this.numeroMesaAsignar
        cantidad = cantidad == 0 ? 1 : cantidad

        this.data.push({
          'companiasId':compania,
          'cantidad':cantidad
        })
        this.listaMuestra = []
        this.servicio.guardar(this.data[0])
        .subscribe(
          res => {
              this.loader = this.loaders.create({});
              this.loader.present();
              this.listaMuestra = []
              this.buscarDatos();
              this.loader.dismiss()
              this.utils.mensajeMuestro('Mesas',`Registro guardado con exito`,'success')
          },
          err => {
            this.loader = this.loaders.create({});
            this.loader.present();
            this.utils.mensajeMuestro('Mesas',`No se pudo guarda`,'error')
          }
        )
    })

    }

    mostrarMensajeDeError(mensaje) {
      let alert = this.alertControllers.create({
        title: 'Error',
        subTitle: mensaje,
        buttons: ['Cerrar']
      });
      alert.present();
      this.loader.dismiss()
    }

    mostrarMensajes(mensaje,advertencia) {
      let alert = this.alertControllers.create({
        title: advertencia,
        subTitle: mensaje,
        buttons: ['Ok']
      });
      alert.present()
    }

    mostrarMensaje(mensaje,advertencia) {
      let alert = this.alertControllers.create({
        title: advertencia,
        subTitle: mensaje,
        buttons: ['Ok']
      });
      alert.present();
      this.loader.dismiss()
    }



    agregar(){
      this.listaMuestra= []
      let cantidad:number  =  this.cantidades
      if(this.mesas == undefined){
        this.mesas = 1
      }
      if(this.sillas == 0){
        this.sillas = 1
      }
      for(var i =0; i< this.mesas;i++){
        let uuid = UUID.UUID();
        let valor:string = ''
        valor = cantidad.toString()
        this.cantidades = this.lista.length + 1
        this.lista.push({'Uuid':uuid ,'id': this.cantidades ,color: this.colores.coloresId
                        ,  'width':this.width,
                        'height':this.height,startLeft:this.startLeft,
                        startTop:this.startTop,sillas: this.sillas})

        this.listasillas.push({'idmesas':uuid,'id':this.sillas,'cantidad':this.sillas})

      }
      this.actualizar['valor']= false
    }


  ionViewDidLoad() {
  }

  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

  eliminarMesa(id:any){
    if(NUBE_AWS){
      this.storages.get('companiasId').then((val)=>{
      this.servicio.eliminarMesasConComandasPorCompania(val,id)
        .subscribe(
          res => {
            this.utils.mensajeMuestro('Mesas',`Registro gestionado, recuerde para eliminar una mesa no puede tener un pedido pendiente`,'success')
            this.listaMuestra = []
            this.buscarDatos();
          },
          err => {
            this.utils.mensajeMuestro('Mesas','No se pudo generar el eliminación de la mesa','error')
          }
        )
    })
    } else {
      this.servicio.eliminar(id)
        .subscribe(
          res => {
            this.utils.mensajeMuestro('Mesas',`La mesa # ${id} fue eliminada`,'success')
          },
          err => {
            this.utils.mensajeMuestro('Mesas','No se pudo generar el eliminación de la mesa','error')
          }
        )
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/mesas/mesas.ts